import * as types from './mutation-types'

export default {
  [types.SET_MAGAZINE](state, payload) {
    state.magazine = payload
  },
}
